import { render } from "./RelationshipTips.vue?vue&type=template&id=8c009d64"
import script from "./RelationshipTips.vue?vue&type=script&lang=js"
export * from "./RelationshipTips.vue?vue&type=script&lang=js"

import "./RelationshipTips.vue?vue&type=style&index=0&id=8c009d64&lang=scss"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__